const routes = [
  {
    path: '/people',
    name: 'People',
    redirect: { name: 'Recruit' },
    component: {
      render: (r) => r('router-view')
    },
    children: [
      {
        path: 'recruit',
        name: 'Recruit',
        component: {
          render: (r) => r('h1', 'Personal')
        }
      }
    ]
  }
]

export default routes
